import { Plan } from 'Features/pricing/types/Plan'
import { CurrenciesTypes } from 'Types/Currencies'
import { PlanTypes } from 'Types/PlansTypes'
import { PRODUCT_TYPES, ProductTypes } from 'Types/ProductTypes'
import { PlanTypesSorted } from 'Features/pricing/types/PlanTypesSorted'

export const useGetPlan = () => {
  const findPlan = (
    plans: Array<Plan>,
    planType: PlanTypes,
    currency: CurrenciesTypes,
    productType: ProductTypes,
    visits: number,
    billingCycleInMonths: number
  ) => {
    return plans
      ? plans.find(
          (plan) =>
            plan.planType === planType &&
            plan.currency === currency &&
            plan.visitsAllowed === visits * 1000 &&
            plan.productType.toLowerCase() === productType.toLowerCase() &&
            plan.billingCycleMonths === billingCycleInMonths
        )
      : undefined
  }

  const sortPlansByType = (plans: Array<Plan>) => {
    const planTypes: PlanTypesSorted = {
      paidMarketing: [],
      botMitigation: [],
      bundles: [],
    }

    plans.forEach((plan) => {
      planTypes.bundles.push(plan)
      if (plan.productType.toLowerCase() === PRODUCT_TYPES.PAID_MARKETING) {
        planTypes.paidMarketing.push(plan)
      } else if (plan.productType.toLowerCase() === PRODUCT_TYPES.BOT_ZAPPING) {
        planTypes.botMitigation.push(plan)
      }
    })
    return planTypes
  }

  return { findPlan, sortPlansByType }
}
